export default __webpack_public_path__ + "static/media/Login2.e393274d.png";